/**
 * Llamadas de autenticación.
 * Todas las respuestas se validan contra el contrato compartido.
 */

import {
  zAuthResponse,
  zOkResponse,
  zUserPublic,
  type AuthResponse,
  type LoginRequest,
  type RegisterRequest,
  type UserPublic,
} from '@eldescuadre/contracts';
import { z } from 'zod';

import { request, setAccessToken } from './api';

const zMeResponse = z.object({ user: zUserPublic });

export async function login(input: LoginRequest): Promise<AuthResponse> {
  const result = await request('/api/auth/login', {
    method: 'POST',
    body: input,
    schema: zAuthResponse,
  });
  setAccessToken(result.accessToken);
  return result;
}

export async function register(input: RegisterRequest): Promise<AuthResponse> {
  const result = await request('/api/auth/register', {
    method: 'POST',
    body: input,
    schema: zAuthResponse,
  });
  setAccessToken(result.accessToken);
  return result;
}

export async function fetchMe(): Promise<UserPublic> {
  const result = await request('/api/auth/me', { schema: zMeResponse });
  return result.user;
}

/**
 * Guarda el token de una sesión que ya viene resuelta.
 *
 * Lo usa la entrada con huella: el servidor devuelve **exactamente lo mismo** que con la
 * contraseña, así que el token se guarda igual y a partir de aquí no hay ninguna
 * diferencia entre haber entrado de una forma o de la otra.
 */
export function acceptSession(accessToken: string): void {
  setAccessToken(accessToken);
}

export async function logout(allDevices = false): Promise<void> {
  try {
    await request('/api/auth/logout', {
      method: 'POST',
      query: allDevices ? { all: 'true' } : undefined,
      schema: zOkResponse,
    });
  } finally {
    setAccessToken(null);
  }
}

export async function changePassword(
  currentPassword: string,
  newPassword: string,
): Promise<void> {
  try {
    await request('/api/auth/change-password', {
      method: 'POST',
      body: { currentPassword, newPassword },
      schema: zOkResponse,
    });
  } finally {
    // El servidor cierra todas las sesiones al cambiar la contraseña.
    setAccessToken(null);
  }
}
